export const of_parties_displayed_columns_locale = {
  type: "Party type",
  name: "Company name",
  account: "Client no.",
  vatNumber: "VAT no.",
  status: "Status",
};
